import type React from 'react'
import {clsx} from 'clsx'
import styles from './InputLabel.module.css'

type BaseProps = {
  disabled?: boolean
  required?: boolean
  visuallyHidden?: boolean
  id?: string
  className?: string
  children?: React.ReactNode
}

export type LabelProps = BaseProps & {
  htmlFor?: string
  as?: 'label'
}

export type LegendOrSpanProps = BaseProps & {
  as: 'legend' | 'span'
  htmlFor?: undefined
}

export type InputLabelProps = LabelProps | LegendOrSpanProps

/**
 * Primer-styled input label for forms; can also be rendered as a fieldset `legend`.
 * Copied from `primer/react/src/internal/components/InputLabel.tsx`.
 */
const InputLabel = ({
  children,
  disabled,
  required,
  visuallyHidden,
  as: Component = 'label',
  className,
  ...props
}: InputLabelProps) => {
  return (
    <Component
      className={clsx(styles.InputLabel, disabled && styles.disabled, visuallyHidden && 'sr-only', className)}
      {...props}
    >
      {required ? (
        <span className={styles.requiredWrapper}>
          <div className={styles.requiredContent}>{children}</div>
          <span>*</span>
        </span>
      ) : (
        children
      )}
    </Component>
  )
}

export default InputLabel
